"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deleteRecommendActivity = deleteRecommendActivity;
exports.getRecommendActivityDetail = getRecommendActivityDetail;
exports.getRecommendActivityPage = getRecommendActivityPage;
exports.saveRecommendActivity = saveRecommendActivity;
exports.toggleActivityStatus = toggleActivityStatus;
var _requestPIM = _interopRequireDefault(require("@/utils/requestPIM"));
var requestUrl = '/xyRecommendActivity';

// 分页查询活动列表
function getRecommendActivityPage(query) {
  return (0, _requestPIM.default)({
    url: requestUrl + '/page',
    method: 'get',
    params: query
  });
}

// 获取活动详情
function getRecommendActivityDetail(activityId) {
  return (0, _requestPIM.default)({
    url: requestUrl + '/' + activityId,
    method: 'get'
  });
}

// 保存活动（新增或更新）
function saveRecommendActivity(data) {
  return (0, _requestPIM.default)({
    url: requestUrl,
    method: 'post',
    data: data
  });
}

// 删除活动
function deleteRecommendActivity(activityId) {
  return (0, _requestPIM.default)({
    url: requestUrl + '/' + activityId,
    method: 'delete'
  });
}

// 切换活动状态
function toggleActivityStatus(data) {
  return (0, _requestPIM.default)({
    url: requestUrl + '/toggleStatus',
    method: 'post',
    data: data
  });
}